import { Button } from "newui/components/Button";

export interface ValidationBannerProps {
	message: string;
	actionLabel?: string;
	onAction?: () => void;
	testId?: string;
}

/**
 * A single bordered/contained validation treatment, shared wherever a page
 * needs to surface "this can't be sent yet" above the form rather than
 * leaving the user to find a bare inline error. The action button is
 * optional — omit both `actionLabel` and `onAction` for a message with
 * nothing to navigate to.
 */
export const ValidationBanner = ({ message, actionLabel, onAction, testId }: ValidationBannerProps) => {
	return (
		<div
			className="mb-4 rounded-md border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-700"
			data-testid={testId}
		>
			<div className="flex items-center justify-between gap-4">
				<span>{message}</span>
				{actionLabel && onAction && (
					<Button btntype="secondary" size="sm" onClick={onAction}>
						{actionLabel}
					</Button>
				)}
			</div>
		</div>
	);
};
